<invoice-cash-desk-edit [noClose]="noClose" (onClose)="close()"></invoice-cash-desk-edit>
